import {AError} from '@mintdata/mint-kit/api/values/AError';

export class EvalErrors
{
    public static readonly Nil = new AError('#NULL!');
    public static readonly Div0 = new AError('#DIV/0!');
    public static readonly Value = new AError('#VALUE!');
    public static readonly Ref = new AError('#REF!');
    public static readonly Name = new AError('#NAME?');
    public static readonly Num = new AError('#NUM!');
    public static readonly NA = new AError('#N/A');
    public static readonly Error = new AError('#ERROR!');
    public static readonly Data = new AError('#GETTING_DATA');

    public static readonly UnknownBinaryOperator = new AError('#BinaryOperator');
    public static readonly InvalidOperands = new AError('#InvalidOperands');
    public static readonly InvalidFunctionArg = new AError('#InvalidFunctionArg');
    public static readonly BadRequest = new AError('#BadRequest');
    public static readonly CellRef = new AError('#CellRefError');
    public static readonly SheetRef = new AError('#SheetRefError');
    public static readonly CircularRef = new AError('#CircularRef');
    public static readonly FunctionName = new AError('#FunctionName');
    public static readonly InvalidFormula = new AError('#InvalidFormula');
    public static readonly NeedConversionToLazy = new AError('#NeedConversionToLazy');
    public static readonly NotAFormula = new AError('#NotAFormula');
    public static readonly NotAnEvent = new AError('#NotAnEvent');
}
